module.exports = __webpack_public_path__ + "img/especialista66.6ced37c5.png";